import { Box, Stack, Typography } from "@mui/material";

interface BookingRatingProps {
  rating: number;
}

export default function BookingRating({ rating }: BookingRatingProps) {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // if (isMobile) {
  //   return (
  //     <Box
  //       sx={{
  //         width: "100%",
  //         height: "100%",
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           width: 64,
  //           height: 64,
  //           borderRadius: "50%",
  //           background: "linear-gradient(324deg, rgba(114,78,65,1) 0%, rgba(216,148,123,1) 100%)",
  //           display: "flex",
  //           alignItems: "center",
  //           justifyContent: "center",
  //           boxShadow: "0 4px 12px rgba(114,78,65,0.35)",
  //         }}
  //       >
  //         <Typography sx={{ fontWeight: 700, fontSize: "14px", color: "white" }}>
  //           {rating}%
  //         </Typography>
  //       </Box>
  //     </Box>
  //   );
  // }
  return (
    <Box
      sx={{
        background:
          "linear-gradient(324deg, rgba(114,78,65,1) 0%, rgba(216,148,123,1) 100%)",
        borderRadius: "15px",
        p: 2,
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "18px",
            color: "white",
          }}
        >
          Booking Rating
        </Typography>

        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            border: "1px solid #f0f4f8",
            background:
              "radial-gradient(circle, rgba(216,148,123,1) 0%, rgba(149,102,85,1) 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "18px",
              color: "white",
            }}
          >
            {rating}%
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
